import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DicebearAvatarConfig } from '../dto/dicebear-avatar-config.dto';
import { BackendService } from './backend.service';
import { ProcessResult, QueryResult } from '../components/common-dto/query.dto';
import { AvatarDto } from '../dto/avatar.dto';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AvatarService {
  private apiUrl = 'https://api.dicebear.com/9.x/avataaars/svg';

  constructor(
    private http: HttpClient,
    private backend: BackendService,
    private authService: AuthService
  ) {}

  private getHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    return headers;
  }

  private stripHash(color: string | undefined): string | undefined {
    return color && color.startsWith('#') ? color.substring(1) : color;
  }

  getImage(options: DicebearAvatarConfig = {}): Observable<any> {
    // strip the # symbol from color values
    const strippedOptions: DicebearAvatarConfig = {
      ...options,
      accessoriesColor: this.stripHash(options.accessoriesColor),
      clothesColor: this.stripHash(options.clothesColor),
      facialHairColor: this.stripHash(options.facialHairColor),
      hairColor: this.stripHash(options.hairColor),
      hatColor: this.stripHash(options.hatColor),
      skinColor: this.stripHash(options.skinColor),
    };

    // filter out blank values so they are not sent as query parameters
    // we need to allow for 0 / false values though
    const filteredOptions = Object.fromEntries(
      Object.entries(strippedOptions).filter(([_, value]) => value !== null && value !== undefined && value !== '')
    );

    const params = new HttpParams({
      fromObject: filteredOptions as Record<string, string>,
    });
    return this.http.get(this.apiUrl + (params ? '?' + params : ''), {
      headers: this.getHeaders(),
      responseType: 'text',
    });
  }

  getAvatars(): Observable<QueryResult<AvatarDto>> {
    return this.backend.getQuery('account/avatar', { take: 100 });
  }

  getAvatar(id: string): Observable<AvatarDto> {
    return this.backend.get('account/avatar/' + id);
  }

  createAvatar(avatar: AvatarDto): Observable<ProcessResult> {
    return this.backend.post('account/avatar', avatar);
  }

  updateAvatar(id: string, avatar: AvatarDto): Observable<ProcessResult> {
    if (id === this.authService.getUserId()) {
      this.authService.setAvatar(avatar.avatarAsBase64);
    }

    return this.backend.put('account/avatar/' + id, avatar);
  }
}
